// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.country-code-input {
    display: flex;
    align-items: center;
    width: 100%;
}

.country-select {
    width: 25%;
    background-color: white;
    border-radius: 5px;
    height: 45px;
}

.dark .country-select {
    color: black !important;
    background-color: white;
}

.phone-input {
    flex: 1;
    padding: 8px;
    border-radius: 4px;
}


.country-select .soft-select__control {
    height: 45px !important;
}

.country-select .soft-select__single-value {
    color: black !important;
    background-color: white !important;
}`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/posnavbar/components/addCustomer/components/countryCodeInput/index.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,UAAU;IACV,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,OAAO;IACP,YAAY;IACZ,kBAAkB;AACtB;;;AAGA;IACI,uBAAuB;AAC3B;;AAEA;IACI,uBAAuB;IACvB,kCAAkC;AACtC","sourcesContent":[".country-code-input {\n    display: flex;\n    align-items: center;\n    width: 100%;\n}\n\n.country-select {\n    width: 25%;\n    background-color: white;\n    border-radius: 5px;\n    height: 45px;\n}\n\n.dark .country-select {\n    color: black !important;\n    background-color: white;\n}\n\n.phone-input {\n    flex: 1;\n    padding: 8px;\n    border-radius: 4px;\n}\n\n\n.country-select .soft-select__control {\n    height: 45px !important;\n}\n\n.country-select .soft-select__single-value {\n    color: black !important;\n    background-color: white !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
